import { css } from '@/styled-system/css';

export const verticalNavHeadingStyles = css.raw({
  textStyle: 'heading-xs',
  color: 'text.neutral',
  paddingInline: 'tight',
  paddingBlock: 'tight',
});
